module.exports = __webpack_public_path__ + "img/bigLogo.449836f4.svg";